import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CategoryEnum, RfidAssocProductModel, RfidTagModel, RfIdTagResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { Dimension } from './dimension-service/dimension-service.entity';
import { Pallet } from './pallets/pallets.entity';
import { RackPosition } from './rack-position/rack-position.entity';
import { RfidTagRequest } from './racks/dto/rfid-tag.request';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { InputIdRequest } from '@gtpl/shared-models/warehouse-management';
@Injectable()
export class AppService {
  constructor(@InjectRepository(Pallet) private palletRepository:  Repository<Pallet>,
              @InjectRepository(RackPosition) private rackRepository:  Repository<RackPosition>,
              @InjectRepository(Dimension) private dimensionRepository:  Repository<Dimension>,
              private stockService: FGStockService) {
  }

  getData(): { message: string } {
    return { message: 'Welcome to services/backend!' };
  }

  /**
   * Service to get rfid tag or pallet id or rack id related details
   * @param rfIdTagreqestObj
   * @returns 
   */
   async getRfidTagDetails(rfIdTagreqestObj: RfidTagRequest): Promise<RfIdTagResponse> {
      let categoryType = '';
      let palletEntity = new Pallet();
      let rackEntity = new RackPosition();
     
      // Check which value is coming from request and collect required values
      if(rfIdTagreqestObj.rfId){
        const palletResponse = await this.palletRepository.query("SELECT pallet_id as palletId,assoc_rfid as assocRfId,pallet_no as palletNo FROM `pallet` WHERE FIND_IN_SET('"+rfIdTagreqestObj.rfId+"',assoc_rfid)");
        if(palletResponse.length > 0){
          categoryType = CategoryEnum.PALLET;
          palletEntity = palletResponse[0];
        } else {
          const rackResponse = await this.palletRepository.query("SELECT rack_code as rackCode,rack_position_id as rackPositionId,assoc_rfid as assocRfId,rack_position as rackPosition,rack_level as rackLevel,rack_boundaries as rackBoundaries FROM `rack_position` WHERE FIND_IN_SET('"+rfIdTagreqestObj.rfId+"',assoc_rfid)");
          if(rackResponse.length > 0){
            categoryType = CategoryEnum.RACK;
            rackEntity = rackResponse[0];
          } else {
            throw new ErrorResponse(10000,'No records found for RFID');
          }
        }
      } else if(rfIdTagreqestObj.palletId){
        categoryType = CategoryEnum.PALLET;
        palletEntity = await this.palletRepository.findOne({
          where: {plantId: rfIdTagreqestObj.plantId,palletNo:rfIdTagreqestObj.palletId}
        });
        if(!palletEntity) {
          throw new ErrorResponse(10000,'No records found for Pallet No');
        }
      } else if(rfIdTagreqestObj.rackId){
        categoryType = CategoryEnum.RACK;
        rackEntity = await this.rackRepository.findOne({
            where: {plantId: rfIdTagreqestObj.plantId,rackCode:rfIdTagreqestObj.rackId}
        });
        if(!rackEntity) {
          throw new ErrorResponse(10000,'No records found for Rack No');
        }
      }

      // Prepare respones based on catergory type
      if(categoryType === CategoryEnum.PALLET) {
        const dimensionRes = await this.getDimensionInfo(rfIdTagreqestObj.plantId,palletEntity.palletId,CategoryEnum.PALLET);
        // get product information
        const productResponse = await this.stockService.productDetailsForPalletId(new InputIdRequest(palletEntity.palletId));
        const rfIdModel = new RfidTagModel(rfIdTagreqestObj.plantId,palletEntity.assocRfId,CategoryEnum.PALLET,palletEntity.palletId,palletEntity.palletNo,dimensionRes.length,dimensionRes.breadth,dimensionRes.width)       
        rfIdModel.productInfo = (!productResponse.status)?null:new RfidAssocProductModel(productResponse.data.brand,productResponse.data.specie,productResponse.data.variety,productResponse.data.productForm,productResponse.data.freezingType,productResponse.data.packingStyle,productResponse.data.grade);
        return new RfIdTagResponse(true, 10000, 'RFID Details Retrived Successfully',rfIdModel);
      } else if(categoryType === CategoryEnum.RACK) {
        const dimensionRes = await this.getDimensionInfo(rfIdTagreqestObj.plantId,rackEntity.rackPositionId,CategoryEnum.RACK);
        // get associated pallet id
        const palletResponse = await this.stockService.getPalletDetailsForRackPosition(new InputIdRequest(rackEntity.rackPositionId));
        const rfIdModel = new RfidTagModel(rfIdTagreqestObj.plantId,rackEntity.assocRfId,CategoryEnum.RACK,rackEntity.rackPositionId,rackEntity.rackCode,dimensionRes.length,dimensionRes.breadth,dimensionRes.width,rackEntity.rackBoundaries,rackEntity.rackLevel,rackEntity.rackPosition);
        rfIdModel.assocPalletId = (!palletResponse.status)?null:palletResponse.data.palletNo;
        return new RfIdTagResponse(true, 10000, 'RFID Retrived Successfully',rfIdModel);
      } else {
        throw new ErrorResponse(10000,'No records found for RFID');
      }
  }

  /**
   * get dimension details like length,breadth,width
   * @param plantId 
   * @param categoryId 
   * @param categoryType 
   * @returns 
   */
  async getDimensionInfo(plantId,categoryId,categoryType): Promise<{length,breadth,width}> {
    let length = 0;
    let breadth = 0;
    let width = 0;
    const dimensionEntity = await this.dimensionRepository.findOne({
      where: {plantId: plantId,categoryId:categoryId,category: categoryType}
    });
    if(dimensionEntity){
      const boundaries = dimensionEntity.boundaries.split(':');
      if(boundaries.length>0) {
        length=Number(boundaries[0]);
        breadth=Number(boundaries[1]);
        width=Number(boundaries[2]);
      }
    }
    return {length,breadth,width};
  }
}
